export const Links = {
    CONTACT_US: 'https://support.yet-another-mail-merge.com/hc/en-us/requests/new',
};